import { fetchVehicleEvolution } from '@/api/vehicleevolution'

const state = {
  isLoading: false,
  all: {},
}

const actions = {
  cleanState ({ commit }) {
    commit('cleanState')
  },

  async fetchVehicleEvolution ({ dispatch, commit }) {
    try {
      dispatch('overlay/show', true, { root: true })

      const vehicleEvolution = await fetchVehicleEvolution()

      commit('setAll', vehicleEvolution)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      dispatch('overlay/show', false, { root: true })
    }
  },
}

const mutations = {
  cleanState (state) {
    state.isLoading = false
    state.all = {}
  },

  setAll (state, data) {
    state.all = data
  },

  setLoading (state, isLoading) {
    state.isLoading = isLoading
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
